import React, { useState } from "react";
import styles from "./NewProduct.module.sass";
import CandidateList from "./CandidateList";

const CandidateListView = ({ offer }) => {
    const [candidateListKey, setCandidateListKey] = useState(0);

    return (
        <>
            <div className={styles.shop}>
                <div className={styles.row}>
                    <div className={styles.col}>
                        <CandidateList
                            key={candidateListKey}
                            className={styles.card}
                            offer={offer}
                            readOnly={true}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default CandidateListView;
